import {GuidesCount} from '@blesk-frontend/api';
import {getPrivateAxios} from '../../libs';

/**
 * Fetch the numbers (unarchived, favorites, archived) of guides.
 */
export const fetchGuidesCount = async () => {
  const {data} = await getPrivateAxios().get<GuidesCount>('/guides/count');
  return data;
};
